import React, { useState } from 'react';
import JourneyModal from './JourneyModal';
import { FaReact, FaNodeJs, FaDatabase, FaGitAlt, FaBriefcase, FaMicrochip, FaFigma, FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import { SiMongodb, SiExpress, SiJavascript, SiTypescript } from 'react-icons/si';
import '../styles/About.css';

const About = () => {
  const [showJourney, setShowJourney] = useState(false);
  const [, setClickCount] = useState(0);
  const [clickTimer, setClickTimer] = useState(null);

  const handleProfileClick = () => {
    setClickCount(prev => {
      const next = prev + 1;
      if (next === 3) {
        window.__showDevMeme?.();
        return 0;
      }
      return next;
    });
    clearTimeout(clickTimer);
    setClickTimer(setTimeout(() => setClickCount(0), 600));
  };

  const techStack = [
    { name: 'React', icon: <FaReact /> },
    { name: 'Node.js', icon: <FaNodeJs /> },
    { name: 'MongoDB', icon: <SiMongodb /> },
    { name: 'Express', icon: <SiExpress /> },
    { name: 'JavaScript', icon: <SiJavascript /> },
    { name: 'TypeScript', icon: <SiTypescript /> },
    { name: 'Git', icon: <FaGitAlt /> },
    { name: 'GitHub', icon: <FaGithub /> },
    { name: 'Database', icon: <FaDatabase /> },
    { name: 'Figma', icon: <FaFigma /> },
  ];

  const stats = [
    { icon: <FaBriefcase />, number: '5+', label: 'Projects Completed' },
    { icon: <FaMicrochip />, number: '8', label: 'Technologies' },
    { icon: <FaExternalLinkAlt />, number: '4', label: 'Live Projects' },
  ];

  return (
    <>
      <section id="about" className="about">
        <div className="about-container">
          <div className="glass-card">
            <div className="about-content">
              <div className="about-left">
                <div className="about-header">
                  <h2 className="about-title">About Me</h2>
                  <div className="title-accent"></div>
                </div>

                <div className="about-bio">
                  <p>
                    I am a <span className="highlight">Full Stack Developer</span> based in Indore with a passion for building scalable web applications. When I'm not coding elegant solutions or solving DSA problems, you can find me exploring the latest in <span className="highlight">Web3 technology</span>.
                  </p>
                  <p>
                    My journey in software development has equipped me with expertise in modern web technologies, from crafting intuitive user interfaces to architecting robust backend systems. I thrive on transforming complex problems into simple, beautiful, and intuitive solutions.
                  </p>
                </div>

                <div className="tech-stack-section">
                  <h3 className="tech-stack-title">Tech Stack</h3>
                  <div className="tech-stack-grid">
                    {techStack.map((tech, index) => (
                      <div key={index} className="tech-bubble" title={tech.name}>
                        {tech.icon}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="stats-grid">
                  {stats.map((stat, index) => (
                    <div key={index} className="stat-card">
                      <div className="stat-icon">{stat.icon}</div>
                      <div className="stat-number">{stat.number}</div>
                      <div className="stat-label">{stat.label}</div>
                    </div>
                  ))}
                </div>

                <div className="about-actions">
                  <button className="journey-btn" onClick={() => setShowJourney(true)}>
                    My Journey
                  </button>
                </div>
              </div>

              <div className="about-right">
                <div className="profile-image-container">
                  <div className="image-glow"></div>
                  <img
                    src="/Pixel art developer with teal accents.png"
                    alt="Profile"
                    className="profile-image"
                    onClick={handleProfileClick}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showJourney && <JourneyModal onClose={() => setShowJourney(false)} />}
    </>
  );
};

export default About;